<template>
  <div class="page drainage-rule">
    <navigation class="header">活动规则</navigation>
    <van-tabs
      v-model="active"
      v-show="!tabItem"
      line-width="84"
      line-height="4"
      background='#fff'
      color="#333"
      title-active-color="#000"
      title-inactive-color="#999"
      :sticky="true"
      :offset-top="128"
    >
      <van-tab title="尊享卡"> </van-tab>
      <van-tab title="轻享卡"> </van-tab>
    </van-tabs>
    <div class="body">
      <div
        class="section"
        v-for="(item, index) in rules[active]"
        :key="index"
      >
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc">
          <div v-html="item.desc"></div>
        </div>
      </div>
    </div>
    <footer>活动所有解释权归天美贷所有</footer>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant'
export default {
  name: 'vip-rule',
  data () {
    return {
      active: 0,
      tabItem: null,
      rules: [
        [
          {
            title: '一、小美尊享VIP会员权益内容-金融权益'
          },
          {
            title: '1 免息返现',
            desc: `
                            （1）权益内容：月卡20元*1张，半年卡20元*3张，年卡20元*6张 <br />

                            （2）返现规则：一张免息券的免息额度为1000元，返最后2期利息，最高可返现利息为20元，最低返现金额为12元。利息减免金额将在关联订单正常还款后的5个工作日内，以现金方式发放至您绑定的银行卡<br />

                            （3）发放方式：购买会员卡后免息券自动发放至券包，半年卡和年卡自购买之日起计算，每两个月发放1次，免息券有效期30天<br />

                            （4）使用规则：提现页面勾选“小美VIP优惠”使用；或者通过“我的券包”进行提现使用，如用户同时拥有两张免息券，则提现时默认优先使用有效期最近的券<br />

                            （5）逾期或者提前结清均不能享有<br />

                            （6）免息券有效期内，如提现失败导致免息券未成功使用，免息券将退回到券包<br />

                            （7）免息券补发规则：仅适用于半年卡和年卡会员<br />

                                    *补发条件：a 免息券有效期间，用户因天美贷产品限制无法提现导致优惠券过期未使用  b 提现失败导致优惠券过期未使用<br />

                                    *补发规则：免息券失效后立即补发至券包，有效期为30天，每张券仅补发1次，请通过“我的券包”查看<br />



                        `
          },
          {
            title: '2 专属提额机会',
            desc: `
                            （1） 提升额度：月卡500元*1次，半年卡1000元*3次，年卡1000元*6次<br />

                            （2）提额规则：月卡有效期内1次，半年卡和年卡自购卡日起，每两个月1次<br />

                            （3）提额方式：通过会员权益页面申请提额，提额成功后总额度自动提升<br />

                            （4）额度有效期：获得额度后30个自然日内借款有效，额度不可拆分使用，如本次未使用完，则剩下的部分失效<br />

                            （5）使用规则：获得额度后进行提现，则默认优先使用该额度；也可以通过“我的券包”提现使用<br />

                            （6）提额成功率不做保证，根据用户个人资质评估<br />
                        `
          },
          {
            title: '3 拒就赔特权',
            desc: `
                            （1）赔付金额：月卡最高15元，半年卡最高60元，年卡最高110元<br />

                            （2）拒就赔范围：<br />

                                    *购买会员至会员失效，用户从未授信申请或者提现申请成功过<br />

                            （3）领取规则：满足以上赔付规则的用户，可在会员失效后的30个自然日内，登录“天美贷app---我的券包”领取并提现现金红包，最高可提现金额为110元，过期则不可提现<br />
                        `
          },
                         
          {
            title: '二、小美尊享VIP会员权益内容-其他权益'
          },
          {
            desc: `
                            （1）优先放款：购买会员卡的用户，会员卡有效期间可获得审批提速90%，享VIP优先放款的特权，用户在提现时享用<br />
                            （2）免费热门会员、话费充值折扣、2折出行，5折看电影：每个月可享有1次对应权益（需每月使用权益，如某月未使用则视为放弃失效），通过会员权益页面即可进入领取页面<br />
                            （3）省钱卡的生活权益内容会根据实际情况有部分调整<br/>
                            （4）如会员卡过期，则会员权益均失效<br/>
                            （5）月卡有效期为30天，半年卡有效期为180天，年卡有效期为360天
                        `
          },
          {
            title: '三、退款规则',
            desc: `
                            会员开通后，原则上不可退款，权益内容一经使用概不退款。如有权益内容的相关问题请拨打客服热线
                        `
          },
          {
            title: '四、特别说明',
            desc: `
                            (1) 用户授信/提现成功率根据用户综合资质评定，该权益不会提升用户授信/提现成功率 <br>
                            (2) 小美VIP的金融类权益仅限天美贷自营贷款有效，不适用于第三方贷款平台，如会员卡过期，则会员权益均失效
                        `
          }
        ],
        [
          {
            title: '一、小美轻享VIP会员权益内容-金融权益'
          },
          {
            title: '1 免息返现',
            desc: `
                            （1）权益内容：月卡20元*1张，半年卡20元*3张，年卡20元*6张 <br />

                            （2）返现规则：一张免息券的免息额度为1000元，返最后2期利息，最高可返现利息为20元，最低返现金额为12元。利息减免金额将在关联订单正常还款后的5个工作日内，以现金方式发放至您绑定的银行卡 <br />

                            （3）发放方式：购买会员卡后免息券自动发放至券包，半年卡和年卡自购买之日起计算，每两个月发放1次，免息券有效期30天 <br />

                            （4）使用规则：提现页面勾选“小美VIP优惠”使用；或者通过“我的券包”进行提现使用，如用户同时拥有两张免息券，则提现时默认优先使用有效期最近的券 <br />

                            （5）逾期或者提前结清均不能享有 <br />

                            （6）免息券有效期内，如提现失败导致免息券未成功使用，免息券将退回到券包 <br />

                            （7）免息券补发规则：仅适用于半年卡和年卡会员 <br />

                                    *补发条件：a 免息券有效期间，用户因天美贷产品限制无法提现导致优惠券过期未使用  b 提现失败导致优惠券过期未使用 <br />

                                    *补发规则：免息券失效后立即补发至券包，有效期为30天，每张券仅补发1次，请通过“我的券包”查看 <br />

                        `
          },
          {
            title: '2 专属提额机会',
            desc: `
                            （1） 提升额度：月卡500元*1次，半年卡1000元*3次，年卡1000元*6次<br />

                            （2）提额规则：月卡有效期内1次，半年卡和年卡自购卡日起，每两个月1次<br />

                            （3）提额方式：通过会员权益页面申请提额，提额成功后总额度自动提升<br />

                            （4）额度有效期：获得额度后30个自然日内借款有效，额度不可拆分使用，如本次未使用完，则剩下的部分失效<br />

                            （5）使用规则：获得额度后进行提现，则默认优先使用该额度；也可以通过“我的券包”提现使用<br />

                            （6）提额成功率不做保证，根据用户个人资质评估
                        `
          },
          {
            title: '3 拒就赔特权',
            desc: `
                            （1）赔付金额：月卡最高15元，半年卡最高50元，年卡最高100元<br />

                            （2）拒就赔范围：<br />

                                    *购买会员至会员失效，用户从未授信申请或者提现申请成功过<br />

                            （3）领取规则：满足以上赔付规则的用户，可在会员失效后的30个自然日内，登录“天美贷app---我的券包”领取并提现现金红包，最高可提现金额为100元，过期则不可提现<br />
                        `
          },
          {
            title: '二、小美轻享VIP会员权益内容-其他权益'
          },
          {
            desc: `
                            （1）优先放款：购买会员卡的用户，会员卡有效期间可获得审批提速80%，享VIP优先放款的特权，用户在提现时享用<br />
                            （2）轻享版的生活权益内容会根据供应商的实际情况进行调整<br />
                            （3）如会员卡过期，则会员权益均失效<br/>
                            （4）月卡有效期为30天，半年卡有效期为180天，年卡有效期为360天
                        `
          },
          {
            title: '三、退款规则',
            desc: `
                            会员开通后，原则上不可退款，权益内容一经使用概不退款。如有权益内容的相关问题请拨打客服热线
                        `
          },
          {
            title: '四、特别说明',
            desc: `
                            (1) 用户授信/提现成功率根据用户综合资质评定，该权益不会提升用户授信/提现成功率 <br>
                            (2) 小美VIP的金融类权益仅限天美贷自营贷款有效，不适用于第三方贷款平台，如会员卡过期，则会员权益均失效
                        `
          }
        ]
      ]
    }
  },
  components: {
    'van-tab': Tab,
    'van-tabs': Tabs
  },
  mounted () {
    this.tabItem = this.$route.query.tabItem
    this.active = Number(this.$route.query.tabItem)
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.page.drainage-rule {
  background: #fcd8aa;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .van-tabs--line .van-tabs__wrap {
    height: 98px;
  }
  .van-tab {
    font-size: 36px;
    height: 98px;
    line-height: 98px;
  }
  .van-tab__text1 {
    height: 98px;
  }
  .header {
    flex-shrink: 0;
  }
  .body {
    background-color: #fff; 
    padding-bottom: 40px;
    border-radius: 30px;
    margin: 40px 40px;
    flex: 1;
    flex-shrink: 0;
    .activity-time {
      margin: 68px 40px 47px 40px;
      font-size: 32px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: #333;
      line-height: 45px;
    }
    .section {
      .title {
        padding: 40px 40px 0px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        line-height: 45px;
      }
      .desc {
        border-radius: 16px;
        padding: 10px 40px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        margin-top: 10px;
      }
    }
  }

  footer {
    flex-shrink: 0;
    font-size: 22px;
    color: #fff;
    text-align: center;
    margin-top: 65px;
    margin-bottom: 45px;
  }
}
</style>
